import React, { useState, useEffect } from 'react';
import { Drawer, Button } from 'antd';
import styles from './index.module.scss';
import { MenuUnfoldOutlined } from '@ant-design/icons';

export type Props = {
  menus?: any;
};

const DrawerMenu: React.FC<Props> = (props) => {
  const { menus = [] } = props;

  const [state, setState] = useState<any>({
    visible: false,
    placement: 'left',
  });

  const onMenuClick = (item: any) => {
    // push to item.link
    // console.log("push to item.link...");

    if (item.onClick) {
      item.onClick();
    }
  };

  useEffect(() => {
    // console.log("visible =>", state.visible);
  }, [state.visible]);

  return (
    <>
      <MenuUnfoldOutlined
        className={styles.hamburger}
        onClick={() => {
          setState({ ...state, visible: !state.visible });
        }}
      />
      <Drawer
        title="พร้อมดี"
        placement={state.placement}
        closable={true}
        onClose={() => {
          setState({ ...state, visible: false });
        }}
        visible={state.visible}
        key={state.placement}
        width={'70%'}
      >
        <div
          className={[styles.menuItem, styles.mainMenus].join(' ')}
        >
          <ul>
            {menus.map((item: any, index: number) => (
              <li key={index}>
                <a
                  onClick={() => {
                    onMenuClick(item);
                  }}
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </Drawer>
    </>
  );
};

export default DrawerMenu;
